import React, { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import StoreCard from "@/components/StoreCard";
import { api } from "@/lib/api";

export default function Stores() {
  const [stores, setStores] = useState([]);
  useEffect(() => {
    api.get("/merchants", { params: { limit: 60 } }).then(({ data }) => setStores(data));
  }, []);
  return (
    <Layout>
      <section className="border-b border-[#E5E3DD] bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-12">
          <div className="overline mb-2">All stores</div>
          <h1 className="font-heading text-4xl md:text-5xl tracking-tight">Independent Canadian shops</h1>
          <p className="text-[#5C5A56] font-light mt-3 max-w-2xl">
            Every store on MapleMarket is run by a real Canadian merchant. Browse them all here.
          </p>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-6 md:px-12 py-12 grid md:grid-cols-3 gap-6" data-testid="stores-grid">
        {stores.map((s) => <StoreCard key={s.merchant_id} store={s} />)}
      </section>
    </Layout>
  );
}
